import { Pagination } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Table } from "reactstrap";
import { fetchPOsUtil } from "../utility";
import TableSkeleton from "./skeleton/TableSkeleton";
const TableRow = React.memo(({ row, onClick }) => {
  return (
    <tr
      className={`${
        row?.purchaseOrderStatus === "cancel" ? "bg-danger text-white" : ""
      }`}
    >
      <td
        className={`pointer ${
          row?.purchaseOrderStatus === "cancel" ? "text-white" : "text-primary"
        }`}
        onClick={onClick}
      >
        <div className="d-flex flex-column justify-content-center">
          <p className="mb-0 text-start fs-14"> {row?.id}</p>
          <small
            className={`fs-12 ${
              row?.purchaseOrderStatus === "cancel"
                ? "text-white"
                : "text-secondary"
            }`}
          >
            {moment(row?.created_at).format("L")}
          </small>
        </div>
      </td>
      <td>
        <span
          className={`${row?.vendor?.company?.length > 20 ? "fs-12" : "fs-14"}`}
        >
          {row?.vendor?.company}
        </span>
      </td>
      <td>${(parseFloat(row?.total) || 0).toFixed(2)}</td>
    </tr>
  );
});
const RightBarPos = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { all_purchase_orders } = useSelector((state) => state.orders);
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const pageSize = 50;
  const handleRowClick = (row) => {
    history.push({
      pathname: `/admin/update-purchase-orders-details/${row?._id}`,
      state: {
        obj: row,
        vendor: {
          billing: [row?.vendor],
          id: row?.vendorOrderId,
          _id: row?.vendorId,
        },
      },
    });
  };
  const gettingPos = () => {
    fetchPOsUtil({
      page,
      search: "",
      pageSize,
      selectedItem: "",
      setLoading,
      dispatch,
      setTotalPages,
    });
  };
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      gettingPos();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [page]);
  useEffect(() => {
    if (all_purchase_orders?.length > 0) {
      setPurchaseOrders(all_purchase_orders ?? []);
    }
  }, [all_purchase_orders]);
  return (
    <div style={{ height: "100%", overflowY: "scroll" }}>
      {loading ? (
        <TableSkeleton columns={3} rows={15} />
      ) : (
        <Table
          responsive
          hover
          bordered
          style={{
            fontSize: "13px",
            overflow: "hidden",
          }}
        >
          <thead className="bg-primary-color text-white">
            <tr>
              <th>#</th>
              <th>Vendor</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {purchaseOrders
              ?.sort((a, b) => b.id - a.id)
              ?.map((row, index) => (
                <TableRow
                  key={index}
                  row={row}
                  onClick={() => handleRowClick(row)}
                />
              ))}
          </tbody>
        </Table>
      )}
      {purchaseOrders?.length > 0 && !loading && (
        <div className="w-100">
          <Pagination
            defaultCurrent={page}
            total={totalPages}
            onChange={(value) => {
              setPage(value);
            }}
            pageSize={pageSize}
            showSizeChanger={false}
          />
        </div>
      )}
    </div>
  );
};
export default RightBarPos;
